export const CustomViewComponentsMap: any = {
}